import formatStringToMMddyyyy from './formatStringToMMddyyyy';

const DATE_FORMATS = {
    MONTH_DAY_YEAR: 'MM/dd/yyyy',
};

const getFormattingFunction = (format: string) => {
    switch (format) {
        case DATE_FORMATS.MONTH_DAY_YEAR:
            return formatStringToMMddyyyy;
        default:
            return formatStringToMMddyyyy;
    }
};

export default getFormattingFunction;
